import cloneDeep from 'lodash/cloneDeep';

const getters = {
  getList: (state) => state.list,
  getPageInfo: (state) => state.pageInfo,
  getDetail: (state) => cloneDeep(state.detail),
  getServiceableArea: (state) => state.serviceableAreas
};
export default getters;
